import { ArticleHeading } from '../../ArticlePage/InthisArticle/styled';
import { ClinicHealthContainer } from '../../Clinic/HealthPlan/styled';
import TopicFilterList from '../TopicFilterList';

export default function DesktopFilter({
  mutate,
  setShowLoader,
  selectedFilter,
}) {
  return (
    <>
      <ArticleHeading>Filter By Stage</ArticleHeading>
      <ClinicHealthContainer topicListing>
        <TopicFilterList
          setShowLoader={setShowLoader}
          mutate={mutate}
          selectedFilter={selectedFilter}
        />
      </ClinicHealthContainer>
    </>
  );
}
